import axios from "axios";

const url = (path) => `${process.env.REACT_APP_API_URL}${path}`;
export const getCourses = () => axios.get(url("/courses"));

export const executeSignup = (data) => {
  return axios.post(url("/signup"), data);
};
